export default "__VITE_ASSET__7NgHkGmQ__"